import React, {useRef, useState} from 'react'
import {toast} from 'react-toastify'
import {ModeleSavDocument, SavDetailResponse} from '../../../../components/sav/Models'
import {ouvrirSavDocument, savErreur, uploadSavDocument} from '../../../../components/sav/requests'
import {formatSavDate} from '../../../../components/sav/libelles'

const LIBELLES: Record<string, string> = {
  PHOTO_CLIENT: 'Photo client',
  JUSTIFICATIF: 'Justificatif',
  BON_RETOUR: 'Bon de retour',
  PHOTO_CONTROLE: 'Photo contrôle',
  PHOTO_COLIS: 'Photo colis',
  MAIL_SOURCE: 'Mail source',
  AVOIR: 'Avoir',
  REPRISE_ODOO: 'Reprise ODOO',
}

export const ouvrirDocument = (document: ModeleSavDocument) =>
  ouvrirSavDocument(document.id).catch((e) =>
    toast.error(savErreur(e, "Le fichier n'a pas pu être ouvert."))
  )

type BoutonProps = {
  dossierId: number
  type: string
  ligne?: number
  libelle: string
  accept?: string
  className?: string
  onAjoute: (detail: SavDetailResponse) => void
}

// Ajout d'une ou plusieurs pièces jointes au dossier
export const SavAjoutDocument = ({
  dossierId,
  type,
  ligne,
  libelle,
  accept = 'image/*,application/pdf',
  className = 'btn btn-sm btn-light-primary',
  onAjoute,
}: BoutonProps) => {
  const champ = useRef<HTMLInputElement>(null)
  const [envoi, setEnvoi] = useState(false)

  const envoyer = async (fichiers: FileList | null) => {
    if (!fichiers?.length) return
    setEnvoi(true)
    try {
      let detail: SavDetailResponse | undefined
      for (const fichier of Array.from(fichiers)) {
        detail = await uploadSavDocument(dossierId, fichier, type, ligne)
      }
      if (detail) onAjoute(detail)
      toast.success('Fichier(s) ajouté(s)')
    } catch (e) {
      toast.error(savErreur(e))
    } finally {
      setEnvoi(false)
      if (champ.current) champ.current.value = ''
    }
  }

  return (
    <>
      <input
        ref={champ}
        type='file'
        multiple
        accept={accept}
        className='d-none'
        onChange={(e) => envoyer(e.target.files)}
      />
      <button
        type='button'
        className={className}
        disabled={envoi}
        onClick={() => champ.current?.click()}
      >
        <i className='bi bi-paperclip'></i> {envoi ? 'Envoi…' : libelle}
      </button>
    </>
  )
}

// Liste des pièces jointes, ouvertes par la route protégée
const SavDocuments = ({documents}: {documents: Array<ModeleSavDocument>}) =>
  documents.length ? (
    <ul className='list-unstyled mb-0'>
      {documents.map((d) => (
        <li key={d.id} className='mb-2'>
          <button
            type='button'
            className='btn btn-link p-0 text-start'
            onClick={() => ouvrirDocument(d)}
          >
            <i
              className={`bi ${
                d.mimeType.startsWith('image/') ? 'bi-image' : 'bi-file-earmark'
              } me-2`}
            ></i>
            {d.nomFichier}
          </button>
          <span className='text-muted fs-7 ms-2'>
            {LIBELLES[d.type] ?? d.type} · {formatSavDate(d.dateCreation)}
          </span>
        </li>
      ))}
    </ul>
  ) : (
    <div className='text-muted'>Aucune pièce jointe.</div>
  )

export default SavDocuments
